import React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import Spinner from '../common/spinner';
import { SET_MARKETING_EMAIL_OPT_IN } from "../../constants/actionTypes";

class OnboardingEmailOptIn extends React.Component {
    constructor(props) {
        super(props);     
        this.state = {
            useEmail: true,          
            emailChanging: false,           
            email: null,
            optIn: null
        };
    }

    componentDidMount() {
        const {showNotificationsScreen } = this.props;      
        logUI("MBHWeb.UI.OnboardingEmailOptIn.ComponentDidMount", new Date(), Tools.getURLPath());
        if (!showNotificationsScreen) {
            //debugger;
            this.props.history.push("/");
            return;
        }      
    }
   

    onEmailChange = (checked) => {     
        this.setState({ emailChanging: true, useEmail: checked, optIn: checked }); //, () => console.log("Email change", this.state));
    }

    updateNotificationsScreenPref() {
        logUI("MBHWeb.UI.OnboardingEmailOptIn.UpdateNotificationsScreenPref", new Date(), Tools.getURLPath());
        this.props.updateNotificationsScreenPreference();
    }

    handleClick = (event, optInBool) => {
        this.setState({ preferencesChanging: true })
        const { email, firstName, lastName, setMarketingEmailOptIn } = this.props;
        try {
            logUI(`MBHWeb.UI.OnboardingEmailOptIn.OptIn${optInBool}`, new Date(), Tools.getURLPath());
            const optInData = [{
                email,
                firstName,
                lastName,
                emailOptInValue: optInBool
            }]
            setMarketingEmailOptIn(optInData);        
        }
        catch (e) {
            console.log('err', e)
        }

        this.updateNotificationsScreenPref();
        this.handleLeavePage();
    }

    handleLeavePage = () => {
        try {
            //debugger;
            this.props.history.push("/");
        }
        catch (e) {
            console.log(e)
            //debugger;
            window.location.href = "/";
        }
    }

    render() {
        const { marketingEmailOptIn } = this.props;
       // console.log("marketingemailoptin", marketingEmailOptIn, typeof(marketingEmailOptIn));

        const promptOptIn = <>
            <div className="row onboarding-notifications__body text-center">
                <div className="col-12">
                    <h1 className="page-heading">One last thing...</h1>
                    <p>At Baylor Scott & White, we are always working on new ways to improve your well-being. Would you like to receive emails with information about our programs and services that may be of interest to you?</p>
                    <>
                        {marketingEmailOptIn.waiting && <Spinner />}
                    </>
                </div>
            </div>
            <div className="row onboarding-notifications__footer text-center">
                {!marketingEmailOptIn.waiting && !marketingEmailOptIn.success && marketingEmailOptIn.error && 
                    <div className="col-12">
                        <div className="error-msg">Unable to update your preference at this time.</div>
                    </div>
                }
                <div className="col-12 onboarding-finish-btn">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={(e) => this.handleClick(e, true)}
                    >
                        OPT IN AND FINISH
                    </button>
                </div>
                <div className="col-12">
                    <button
                        type="button"
                        className="btn text-btn"
                        onClick={(e) => this.handleClick(e, false)}
                    >
                        No Thanks
                    </button>
                </div>
            </div>
        </>

        return (
            <div className="container-fluid body-content onboarding-notifications-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        {promptOptIn}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        showNotificationsScreen: state.session.showNotificationsScreen,
        marketingEmailOptIn: state.marketingEmailOptIn,
        firstName: state.sso.userDetails?.Givenname,
        lastName: state.sso.userDetails?.Surname,
        email: state.sso.userDetails?.Email,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {      
        updateNotificationsScreenPreference: () => dispatch({ type: types.UPDATE_NOTIFICATIONS_SCREEN_PREFERENCE }),      
        setMarketingEmailOptIn: (optInData) => { dispatch({ type: SET_MARKETING_EMAIL_OPT_IN, data: optInData }) }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingEmailOptIn);